const configuredApiUrl = import.meta.env.VITE_API_URL;

export function getApiBaseUrl(): string {
  if (configuredApiUrl != null && String(configuredApiUrl).trim() !== "") {
    return String(configuredApiUrl).replace(/\/+$/, "");
  }

  if (typeof window !== "undefined") {
    const { protocol, hostname, port, origin } = window.location;
    if (protocol === "http:" || protocol === "https:") {
      if (port && port !== "3000" && port !== "3001" && port !== "5173") return origin;
      if (hostname && hostname !== "localhost" && hostname !== "127.0.0.1") return origin;
    }
  }

  return "http://127.0.0.1:8787";
}
